import { ACCESS_TOKEN, REFRESH_TOKEN } from '@/service/constants';
import { USER_INFO } from '@/utils/useLocalStorage';

type SessionListener = () => void;

const listeners = new Set<SessionListener>();

/** 与登录态相关的 localStorage 键；key 为 null 表示 clear()。 */
export const SESSION_STORAGE_KEYS = [ACCESS_TOKEN, REFRESH_TOKEN, USER_INFO] as const;

/** 判断 storage 事件是否可能改变本页登录态。 */
export function isSessionStorageEvent(key: string | null): boolean {
  return key === null || (SESSION_STORAGE_KEYS as readonly string[]).includes(key);
}

/** 订阅同标签页会话变更。localStorage 在当前标签页的写入不会触发 storage 事件。 */
export function subscribeSessionChange(listener: SessionListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** 通知同标签页：token / user-info 已在本地变化，需同步 isLogin。 */
export function notifySessionChange() {
  listeners.forEach((listener) => listener());
}
